import { render, staticRenderFns } from "./CustomMenu.vue?vue&type=template&id=472167f7&scoped=true"
import script from "./CustomMenu.vue?vue&type=script&lang=js"
export * from "./CustomMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomMenu.vue?vue&type=style&index=0&id=472167f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472167f7",
  null
  
)

export default component.exports